import { Grid } from 'antd'
import isEmpty from 'lodash/isEmpty'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toogle_setting } from '../redux/slice/settings'

const { useBreakpoint } = Grid

const MobileViewObserver = () => {
  const screens = useBreakpoint()
  const isMobileView = useSelector(s => s._settings.isMobileView)
  const dispatch = useDispatch()

  const modify = useCallback(() => {
    dispatch(toogle_setting('isMobileView'))
  }, [dispatch])

  useEffect(() => {
    if (!isEmpty(screens)) {
      if (screens.md) {
        if (isMobileView !== false) {
          modify(false)
        }
      } else if (isMobileView !== true) {
        modify(true)
      }
    }
  }, [isMobileView, screens, modify])

  return null
}

export default MobileViewObserver
